import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetDvaDebugFlagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDvaDebugFlagsQuery = { __typename?: 'Query', getDvaDebugFlags: { __typename?: 'DvaDebugFlags', webviewUrl?: string | null, environment?: string | null, preview?: string | null } };


export const GetDvaDebugFlags = /*#__PURE__*/ gql`
    query GetDvaDebugFlags {
  getDvaDebugFlags {
    webviewUrl
    environment
    preview
  }
}
    ` as unknown as DocumentNode<GetDvaDebugFlagsQuery, GetDvaDebugFlagsQueryVariables>;

          

          export const useGetDvaDebugFlagsQuery = (options?:QueryHookOptions<GetDvaDebugFlagsQuery, GetDvaDebugFlagsQueryVariables>) => useQuery(GetDvaDebugFlags, options);

          

          export type GetDvaDebugFlagsQueryOptions = QueryHookOptions<GetDvaDebugFlagsQuery, GetDvaDebugFlagsQueryVariables>;

          

          export const useGetDvaDebugFlagsLazyQuery = (options?:LazyQueryHookOptions<GetDvaDebugFlagsQuery, GetDvaDebugFlagsQueryVariables>) => useLazyQuery(GetDvaDebugFlags, options);

          

          export type GetDvaDebugFlagsQueryResult = ReturnType<typeof useGetDvaDebugFlagsQuery>;

          
